import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EDeleteOfferActionTypes {
  Request = 'DELETE_OFFER/REQUEST',
  Success = 'DELETE_OFFER/SUCCESS',
  Failure = 'DELETE_OFFER/FAILURE',
}

interface IPayload {
  offerId: number;
}

type TDeleteOfferRequest = ITypedReduxAction<EDeleteOfferActionTypes.Request, IPayload>;
type TDeleteOfferSuccess = ITypedReduxAction<EDeleteOfferActionTypes.Success, IPayload>;
type TDeleteOfferFailure = ITypedReduxAction<EDeleteOfferActionTypes.Failure, IPayload>;

export type TDeleteOffer = TDeleteOfferRequest | TDeleteOfferSuccess | TDeleteOfferFailure;

export const deleteOfferRequest = actionGenerator<EDeleteOfferActionTypes.Request, IPayload>(
  EDeleteOfferActionTypes.Request,
);

export const deleteOfferSuccess = actionGenerator<EDeleteOfferActionTypes.Success, IPayload>(
  EDeleteOfferActionTypes.Success,
);

export const deleteOfferFailure = actionGenerator<EDeleteOfferActionTypes.Failure, IPayload>(
  EDeleteOfferActionTypes.Failure,
);
